
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.577 7.238s-.45-1.127-.888-2.202c0 0-.146-.646-.032-1.504 0 0 .311-1.311.138-1.931 0 0-.265-.531-.817-.568 0 0-.762.053-.904.795 0 0-.038.427.08.92 0 0 .427 1.631-.04 2.696 0 0-.653 1.363-.705 1.675 0 0-.244 1.336-.004 2.32 0 0 .505 1.683.875 2.24 0 0 .75.192 1.393-.016 0 0 .77-1.249.925-2.377 0 0 .193-1.192-.021-2.048zm2.402-.793s-.45-1.127-.89-2.202c0 0-.145-.646-.031-1.503 0 0 .311-1.31.138-1.932 0 0-.265-.531-.817-.568 0 0-.762.054-.904.795 0 0-.038.427.082.92 0 0 .427 1.633-.043 2.696l-.227.488c.41 1.006.803 1.99.803 1.99l.006.017.005.017c.225.895.033 2.1.026 2.144-.073.536-.275 1.084-.474 1.53l.03.05s.748.191 1.392-.019c0 0 .77-1.246.925-2.375 0 0 .193-1.192-.021-2.048zM4.614 5.34c.026-.055.047-.117.067-.178l-.371-.915s-.148-.648-.032-1.504c0 0 .31-1.31.138-1.93 0 0-.266-.532-.818-.569 0 0-.762.055-.904.793 0 0-.037.43.083.92 0 0 .427 1.633-.043 2.698 0 0-.652 1.363-.704 1.675 0 0-.245 1.337-.004 2.32 0 0 .505 1.683.874 2.24 0 0 .75.192 1.393-.018l.04-.066a20.899 20.899 0 01-.442-1.308c-.25-1.025-.01-2.369 0-2.42.054-.332.614-1.512.723-1.738z"}})])
          )
        }
      }
    